/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import React from 'react';

import Heading from '../../shared/Heading';
import Text from '../../shared/Text';
import { PodcastImage, SwitchToAnchor } from './styles';

type Props = {
  imageSrc: string;
  authorName: string;
};

export const SwitchToAnchorHero = ({ imageSrc, authorName }: Props) => (
  <SwitchToAnchor>
    <Heading size="md" color="#ffffff" align="center" isBold={true}>
      Switch your podcast to Anchor
    </Heading>
    <div
      css={css`
        margin: 10px 0 40px;
      `}
    >
      <Text align="center" color="#ffffff" size="lg">
        Free hosting, automatic distribution, easy monetization.
      </Text>
    </div>
    <PodcastImage src={imageSrc} />
    <Text align="center" color="#ffffff" size="md" isBold={true}>
      by {authorName}
    </Text>
  </SwitchToAnchor>
);
